import React, { useRef, useState, useEffect } from "react";
import "./Folder.css";
import { useTranslation } from "react-i18next";

const Folder = (props) => {
  const { t } = useTranslation();

  const content = useRef(null);

  const titleUnicode = useRef(null);

  const [toggle, setToggle] = useState(false);

  const handleFolderClick = () => {
    let layerFolderImage = document.querySelector(
      `#folder${props.folderIndex}image`
    );

    layerFolderImage.style.animation = "none";

    if (toggle) {
      content.current.style.visibility = "hidden";

      content.current.style.display = "none";

      content.current.style.opacity = "0";

      setToggle(false);
    } else {
      content.current.style.visibility = "visible";

      content.current.style.display = "inherit";

      content.current.style.opacity = "1";

      setToggle(true);
    }
  };

  const isScoped = () => {
    if (content.current.style.visibility === `visible`) {
      setToggle(true);
    } else {
      setToggle(false);
    }
  };

  useEffect(() => {
    if (!props.sidebarVisible || !content.current) return;

    if (props.hasVisibleLayer) {
      content.current.style.visibility = "visible";
      content.current.style.display = "inherit";
      content.current.style.opacity = "1";
      setToggle(true);
    }
  }, [props.sidebarVisible, props.hasVisibleLayer]);

  return (
    <div
      onMouseOver={isScoped}
      className="LayerFolder"
      id={`folder${props.folderIndex}`}
    >
      <h3 className="LayerFolderTitle" onClick={handleFolderClick}>
        <span className="LayerFolderTitleIcon">
          <i
            id={`folder${props.folderIndex}image`}
            className={`pi ${toggle ? "pi-folder-open" : "pi-folder"}`}
            alt={t("folder.alt")}
          />
        </span>
        <span className="LayerFolderTitleText">{t(props.title)}</span>
      </h3>
      <div ref={content} className="content">
        {props.children}
      </div>
    </div>
  );
};

export default Folder;
